import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@projects/admin/src/app/services/user.service';

@Component({
  selector: 'app-priority-update-modal',
  templateUrl: './priority-update-modal.component.html',
  styleUrl: './priority-update-modal.component.scss',
})
export class PriorityUpdateModalComponent implements OnInit, OnDestroy {
  constructor(public userService: UserService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    //* Clean up work
    this.userService.clearUsersPriorityForm();
  }
}
